import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Pipe({ name: 'booleanText' })
export class BooleanTextPipe implements PipeTransform {

    constructor(private translateService: TranslateService) {

    }

    transform(value: boolean): string {
        return value ? this.translateService.instant('global.yes') : this.translateService.instant('global.no');
    }
}